export default function actHack(callback) {
  callback();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-apollo-hooks/es/internal/actHack.js
// module id = 191
// module chunks = 0